import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMain } from 'contexts/main.context';
import Icon from 'components/icon/icon.component';
import Button from 'components/button/button.component';
import './basic.style.scss';

const Header = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { applicantData } = useMain();
  const routes: string[] = ['profile', 'dashboard', 'history', 'report'];

  return (
    <div className="basicLayout__header">
      <nav className="basicLayout__menu">
        <ul>
          {routes.map((route) => (
            <li key={route} className={location.pathname.includes(route) ? 'active' : ''}>
              <Link to={`/${route}`}>{t(`navigation.${route}`)}</Link>
            </li>
          ))}
        </ul>
      </nav>
      <div>
        {applicantData.applicantName}
        <Button onClick={() => navigate('/sign-in')} primary>
          <Icon name={'LogOut'} size={18} />
        </Button>
      </div>
    </div>
  );
};

export default Header;
